module.exports = __webpack_public_path__ + "static/media/en.ca64a59b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/localised-computers/en.png
// module id = 296
// module chunks = 0